import { render } from "./AcordionItem.vue?vue&type=template&id=9266b192&scoped=true"
import script from "./AcordionItem.vue?vue&type=script&lang=js"
export * from "./AcordionItem.vue?vue&type=script&lang=js"

import "./AcordionItem.vue?vue&type=style&index=0&id=9266b192&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9266b192"]])

export default __exports__